/**
 * 商户组模拟数据
 */
export const merchantGroupList = [
  {
    id: 1,
    groupName: 'VIP商户组',
    merchantIds: [1001, 1002]
  },
  {
    id: 2,
    groupName: '普通商户组',
    merchantIds: [1003, 1005]
  }
]
